<template>
    <div class="about">

        <v-card class="mx-auto overflow-hidden" max-width="600px">
            <v-img
                src="../../public/img/img/about.jpg"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
            >
            <v-card-title v-text="title"></v-card-title>
            </v-img>
            <v-card-text>
                <p>{{paragraph1}}</p>
                <p>{{paragraph2}}</p>
                <p>{{paragraph3}}</p>
                <p>{{paragraph4}}</p>
            </v-card-text>
            <v-divider class="mx-4"></v-divider>
                <v-container fluid>
                    <v-row class="ma2" justify="space-between">
                        <v-col class="pa-3 d-flex flex-column">
                            <v-card class="flex d-flex flex-column">
                                <v-img src="../../public/img/img/icon_security.svg" class="img-fluid mb-4" aspect-ratio="1" max-height="50px" contain></v-img>
                                <v-card-title>Security</v-card-title>
                                <v-card-text>{{security}}</v-card-text>
                            </v-card>
                        </v-col>
                        <v-col class="pa-3 d-flex flex-column">
                            <v-card class="flex d-flex flex-column">
                                <v-img src="../../public/img/img/icon_destination.svg" class="img-fluid mb-4" aspect-ratio="1" max-height="50px" contain></v-img>
                                <v-card-title>Destinations</v-card-title>
                                <v-card-text>{{destination}}</v-card-text>
                            </v-card>
                        </v-col>
                        <v-col class="pa-3 d-flex flex-column">
                            <v-card class="flex d-flex flex-column">
                                <v-img src="../../public/img/img/icon_prices.svg" class="img-fluid mb-4" aspect-ratio="1" max-height="50px" contain></v-img>
                                <v-card-title>Price</v-card-title>
                                <v-card-text>{{price}}</v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
        </v-card>

        <!-- <v-container fluid>
        <v-row dense>
          <v-col
            v-for="card in cards"
            :key="card.title"
            :cols="card.flex"
          >
            <v-card>
              <v-img
                :src="card.src"
                class="white--text align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                height="200px"
              ></v-img>
                <v-card-title v-text="card.title"></v-card-title>
              </v-img>
  
              <v-card-actions>
                <v-spacer></v-spacer>
  
                <v-btn icon>
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
  
                <v-btn icon>
                  <v-icon>mdi-bookmark</v-icon>
                </v-btn>
  
                <v-btn icon>
                  <v-icon>mdi-share-variant</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container> -->
    </div>
</template>

<script>
export default {
    name: 'About', //this is the name of the component
    data(){
        return{
            title: "About Us",
            paragraph1: "We are a Tanzania lovers, who would like to reach out to other people and show them the beauty of this country.",
            paragraph2: "We have visited every province in this amazing country and can put together the perfect holiday tailored to suit you.",
            paragraph3: "For this reason we are in contact with local businesses that offer safari tours. We offer them visibility so that they can sustain their families, and our customers can have the best experiences of wilderness and beach relax, at very affordable prices.",
            paragraph4: "We have a good range of itineraries, wildlife viewing opportunities and we can put together any combination to make the right holiday for you. Whether you prefer 5-star city hotels, luxurious resorts, rustic lodges or country inns, we can arrange it for you.",
            security: "We do care about your security and do not save any personal data nor we share them with third parties",
            destination: "We offer you a selection of safaris and beach holidays, and you can choose the best combination for you.",
            price: "We work with locals, and our focus is on developing their business, without intermediations. By doing so, we can offer you the best price.",
        }
    }
}
</script>